import { Component, OnInit } from '@angular/core';
import {
  ItemView,
  ItemViewProviderDirective,
  NtapGlobalConstants,
  UIComponents,
  Util
} from '@ntap/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-povijest-promjena',
  templateUrl: './povijest-promjena.component.html',
  styleUrls: ['./povijest-promjena.component.scss']
})
export class PovijestPromjenaComponent implements OnInit {
  INIT_COMP_ID = UIComponents.LISTVIEW;

  activeIndex: number;
  init$: Observable<any>;
  currentViewState: object | null = null;
  currentViewName: string;
  currentViewStateFilter: object = {};

  constructor(
    protected parentItemViewProvider: ItemViewProviderDirective<ItemView>
  ) {}

  ngOnInit() {
    this.init$ = this.parentItemViewProvider.item$.pipe(
      map((parentItem: any) => {
        const typeName: string = parentItem[NtapGlobalConstants.ATTR_$itemType];
        const identifikator =
          parentItem[
            Util.getFullAttrName(typeName, NtapGlobalConstants.ATTR_id)
          ];
        this.currentViewName = 'povijest_promjena';
        this.currentViewState = {
          [Util.getFullAttrName('rel~dogadaj_entitet', 'type_name')]:
            typeName.replace(NtapGlobalConstants.FQAN_SEPARATOR, '.'),
          [Util.getFullAttrName('rel~dogadaj_entitet', 'identifikator')]:
            identifikator
        };
        return {};
      })
    );
  }
}
